'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { I18nextProvider, I18nextProviderProps } from 'react-i18next';
import { PropsWithChildren, Suspense } from 'react';

// Config
import i18n from './i18n';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
function TranslationsProvider({
  children,
  ...props
}: PropsWithChildren & Omit<I18nextProviderProps, 'i18n'>) {
  /* ******************************** RENDERING ******************************* */
  return (
    <I18nextProvider defaultNS="Common" {...props} i18n={i18n}>
      <Suspense>{children}</Suspense>
    </I18nextProvider>
  );
}

export default TranslationsProvider;
